import type { IGameState, IPlayerState } from "@shared/types";
import * as THREE from "three";

let gameState: IGameState | null = null;
let localPlayerId: string | null = null;
let localPlayer: IPlayerState | null = null;
const playerMeshes: Record<string, THREE.Group> = {};
const ghostMeshes: Record<string, THREE.Group> = {};
const dotMeshes: THREE.Mesh[] = [];
const wallMeshes: Record<string, THREE.Mesh> = {};
const rocketMeshes: THREE.Group[] = [];
const respawnEffects: Record<
  string,
  { startTime: number; duration: number; mesh?: THREE.Object3D }
> = {};

// Animation state managed as an object with mutable properties
export const animationState = {
  ghostFloatOffset: 0,
  previousPosition: null as THREE.Vector3 | null,
};

// Camera direction as a constant (since it's only copied, not reassigned)
export const lastFacingDirection = new THREE.Vector3(0, 0, -1);

// Handle keyboard input
export const keys: Record<string, boolean> = {};

export function getGameState(): IGameState | null {
  return gameState;
}

export function setGameState(state: IGameState | null): void {
  gameState = state;
}

export function getLocalPlayerId(): string | null {
  return localPlayerId;
}

export function setLocalPlayerId(id: string | null): void {
  localPlayerId = id;
}

export function getLocalPlayer(): IPlayerState | null {
  return localPlayer;
}

export function setLocalPlayer(player: IPlayerState | null): void {
  localPlayer = player;
}

export function getPlayerMeshes(): Record<string, THREE.Group> {
  return playerMeshes;
}

export function getGhostMeshes(): Record<string, THREE.Group> {
  return ghostMeshes;
}

export function getDotMeshes(): THREE.Mesh[] {
  return dotMeshes;
}

export function getWallMeshes(): Record<string, THREE.Mesh> {
  return wallMeshes;
}

export function getRocketMeshes(): THREE.Group[] {
  return rocketMeshes;
}

export function getRespawnEffects(): Record<
  string,
  { startTime: number; duration: number; mesh?: THREE.Object3D }
> {
  return respawnEffects;
}

// Initialize keyboard event listeners
export function initializeKeyboardControls(): void {
  document.addEventListener("keydown", (event) => {
    keys[event.key] = true;

    // Toggle instructions visibility with H key
    if (event.key === "h" || event.key === "H") {
      const instructionsElement = document.getElementById("instructions");
      if (instructionsElement) {
        instructionsElement.classList.toggle("hidden");
      }
    }

    // Use rocket with space key
    if (event.key === " " && localPlayer && localPlayer.hasRocket) {
      // Import dynamically to avoid circular dependency
      import("./effects").then(({ useRocket }) => {
        useRocket();
      });
    }
  });

  document.addEventListener("keyup", (event) => {
    keys[event.key] = false;
  });
}
